import Text from '@deprecated-ui/common/Text';
import { CheckboxProps, Col, Row } from 'antd';
import { ReactNode } from 'react';
import { BoxRow, ButtonContainer, IconCol, MethodCheckbox } from './styled';

export interface SelectCardMethodProps extends Omit<CheckboxProps, 'onClick'> {
  title?: string;
  description?: string;
  icon?: ReactNode;
  onClick?(value: string): void;
}

const SelectCardMethod = ({
  title,
  description,
  icon,
  onClick = () => {},
  ...props
}: SelectCardMethodProps) => (
  <ButtonContainer
    type="button"
    onClick={() => onClick(props.value)}
    isActive={props.checked}
  >
    <BoxRow align="middle" justify="space-between">
      <Col>
        <Row align="middle" gutter={[16, 0]}>
          <IconCol>{icon}</IconCol>

          <Col>
            <Text
              size="14px"
              height="16px"
              color="#333333"
              weight={props.checked ? '700' : '400'}
              // @ts-expect-error
              mb="2px"
            >
              {title}
            </Text>
            <Text size="12px" height="16px" color="#858585">
              {description}
            </Text>
          </Col>
        </Row>
      </Col>

      <Col>
        <MethodCheckbox {...props} />
      </Col>
    </BoxRow>
  </ButtonContainer>
);

export default SelectCardMethod;
